import { render, staticRenderFns } from "./RxSwitch.vue?vue&type=template&id=2416f0be"
import script from "./RxSwitch.vue?vue&type=script&lang=js"
export * from "./RxSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports